import React, { useState } from 'react';
import './market.css';

function Market() {
  const [searchQuery, setSearchQuery] = useState('');
  
  // Featured creators data
  const featuredCreators = [
    {
      id: 1,
      name: "Meal Prep Master",
      description: "I create meal planning templates that help busy families save time and money on groceries.",
      cookbooks: 8
    },
    {
      id: 2,
      name: "Mat med Hillevi",
      description: "Financial expert sharing templates to track grocery spending and save money on food costs.",
      cookbooks: 4
    },
    {
      id: 3,
      name: "Chef Caroline",
      description: "Professional chef offering recipe organization systems and meal planning for foodies.",
      cookbooks: 10
    },
    {
      id: 4,
      name: "Pantry Pro",
      description: "Inventory management specialist helping you organize your kitchen and reduce food waste.",
      cookbooks: 7
    },
    {
      id: 5,
      name: "Seasonal Shopper",
      description: "Guides on seasonal produce shopping to save money and eat fresher ingredients year-round.",
      cookbooks: 12
    }
  ];
  
  // Featured cookbooks data
  const featuredCookbooks = [
    {
      id: 1,
      title: "Weekly Recipe Engine",
      rating: 5.0,
      type: "Free",
      image: "oscar-tracker"
    },
    {
      id: 2,
      title: "Santorini Lunches",
      rating: 4.6,
      type: "55 US$",
      image: "wedding-photography"
    },
    {
      id: 3,
      title: "Husmanskost",
      rating: 4.8,
      type: "Free",
      image: "starter-pack"
    },
    {
      id: 4,
      title: "Portionen Under Tian",
      rating: 4.9,
      type: "Free",
      image: "brand-kit"
    },
    {
      id: 5,
      title: "Seasonal Heroes",
      rating: 5.0,
      type: "9.99 US$",
      image: "life-os"
    },
    {
      id: 6,
      title: "Italian Pizzas",
      rating: 4.7,
      type: "Free",
      image: "world-without-email"
    }
  ];
  
  return (
    <div className="market-container">
      {/* Search bar */}
      <div className="market-search-container">
        <h1 className="market-title">Discover</h1>
        <input
          type="text"
          placeholder="Search templates, creators, or categories..."
          className="market-search-input"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        <div className="search-icon">🔍</div>
      </div>
      
      
      
      {/* Featured sections */}
      <div className="featured-sections">
        {/* Business section */}
        <div className="featured-section business">
          <div className="section-content">
            <div className="section-icon">💼</div>
            <h2>All in one for your grocery planning</h2>
            <p>Kickstart your meal planning with specialized Penny templates</p>
          </div>
          <div className="section-illustration">
            <div className="placeholder-illustration business-illustration"></div>
          </div>
        </div>
        
        {/* Lifestyle section */}
        <div className="featured-section lifestyle">
          <div className="section-content">
            <div className="section-icon">🏖️</div>
            <h2>Transform your weekly shopping to easy and fun</h2>
            <p>Create a shopping list with our specially selected seasonal templates</p>
          </div>
          <div className="section-illustration">
            <div className="placeholder-illustration lifestyle-illustration"></div>
          </div>
        </div>
      </div>
      
      {/* Featured creators section */}
      <div className="creators-section">
        <div className="section-header">
          <h2>Featured creators</h2>
          <button className="view-all-button">View all</button>
        </div>
        
        <div className="creators-scroll">
          <div className="creators-container">
            {featuredCreators.map(creator => (
              <div key={creator.id} className="creator-card">
                <div className="creator-avatar">
                  <div className="avatar-placeholder">
                    {creator.name.charAt(0)}
                  </div>
                  {creator.id <= 3 && <div className="verified-badge">✓</div>}
                </div>
                <h3 className="creator-name">{creator.name}</h3>
                <p className="creator-description">{creator.description}</p>
                <div className="creator-templates">{creator.cookbooks} cookbooks</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* Featured cookbooks section */}
      <div className="cookbooks-section">
        <div className="section-header">
          <h2>Featured cookbooks</h2>
          <button className="view-all-button">View all</button>
        </div>
        
        <div className="cookbooks-grid">
          {featuredCookbooks.map(cookbook => (
            <div key={cookbook.id} className="cookbook-card">
              <div className="cookbook-image">
                <div className={`cookbook-placeholder ${cookbook.image}`}></div>
              </div>
              <div className="cookbook-info">
                <div className="cookbook-avatar">
                  <div className="small-avatar-placeholder">
                    {cookbook.title.charAt(0)}
                  </div>
                </div>
                <h3 className="cookbook-title">{cookbook.title}</h3>
                <div className="cookbook-meta">
                  <div className="cookbook-rating">★ {cookbook.rating.toFixed(1)}</div>
                  <div className="cookbook-type">{cookbook.type}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {/* Categories section
      <div className="categories-section">
        <div className="category-card meal-planning">
          <div className="category-icon">🍽️</div>
          <h3>Meal Planning</h3>
          <p>Weekly and monthly recipe engines</p>
        </div>
        
        <div className="category-card budget">
          <div className="category-icon">💰</div>
          <h3>Budget Tracking</h3>
          <p>Track your grocery spending</p>
        </div>
        
        <div className="category-card recipes">
          <div className="category-icon">📖</div>
          <h3>Recipe Collections</h3>
          <p>Organize your favorite recipes</p>
        </div>
        
        <div className="category-card inventory">
          <div className="category-icon">📦</div>
          <h3>Pantry Inventory</h3>
          <p>Track what's in your kitchen</p>
        </div>
        
        <div className="category-card shopping">
          <div className="category-icon">🛒</div>
          <h3>Shopping Lists</h3>
          <p>Smart shopping list templates</p>
        </div>
        
        <div className="category-card seasonal">
          <div className="category-icon">🍎</div>
          <h3>Seasonal Guides</h3>
          <p>What to buy when it's in season</p>
        </div>
      </div> */}
      
      {/* Become a creator section */}
      <div className="become-creator-section">
        <h2>Become a Penny creator today</h2>
        <p>Share your templates with the Penny community and help others save on groceries</p>
        <button className="become-creator-button">Get started</button>
      </div>
    </div>
  );
}

export default Market; 